import { createTheme } from '@mui/material';
import { UNIVERSAL_THEME_ELEMENTS } from './universal-theme-elements';

export const DARK_MODE = createTheme({
  ...UNIVERSAL_THEME_ELEMENTS,
  palette: {
    text: {
      primary: '#000111',
    },
    primary: {
      main: '#fff',
      contrastText: '#167E99',
    },
  },
});
